import type { AuthToken } from './types';
import axios from 'axios';
import config from '@/config';
import logger from '@/services/logger';

const { authProxyUrl } = config.services;

export const authProxyGetToken = async (postData: any): Promise<AuthToken> => {
  try {
    const { data } = await axios.post(authProxyUrl, postData, {
      headers: { 'Content-Type': 'application/json' },
    });

    logger.info('authProxyGetToken');
    return data;
  } catch (err: any) {
    logger.error('authProxyGetToken', err.message ?? err);
    throw new Error('Error obtaining auth token');
  }
};
